const Logo =()=> <h5 className="application-logo text">Pirates<b>Alert</b></h5>
export default Logo;